import React, { useEffect, useState } from 'react';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { BottomNav } from './BottomNav';
interface LayoutProps {
  children: React.ReactNode;
  currentModule: string;
  onModuleChange: (module: string) => void;
}
export function Layout({
  children,
  currentModule,
  onModuleChange
}: LayoutProps) {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
  useEffect(() => {
    setIsMobileSidebarOpen(false);
  }, [currentModule]);
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768) setIsMobileSidebarOpen(false);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  useEffect(() => {
    document.body.style.overflow = isMobileSidebarOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [isMobileSidebarOpen]);
  const toggleMobileSidebar = () => setIsMobileSidebarOpen(v => !v);
  return <div className="min-h-screen bg-gray-50 dark:bg-gray-900" data-id="element-171">
      {/* Mobile overlay */}
      {isMobileSidebarOpen && <div className="fixed inset-0 bg-black/50 z-40 md:hidden backdrop-blur-sm" onClick={() => setIsMobileSidebarOpen(false)} data-id="element-172" />}

      {/* Sidebar */}
      <div className={`
          fixed inset-y-0 left-0 z-50 md:z-30
          transform transition-all duration-300 ease-in-out
          ${isMobileSidebarOpen ? 'translate-x-0 opacity-100 visible' : '-translate-x-full opacity-0 invisible'}
          md:translate-x-0 md:opacity-100 md:visible
        `} data-id="element-173">
        <Sidebar currentModule={currentModule} onModuleChange={module => {
        onModuleChange(module);
        setIsMobileSidebarOpen(false);
      }} isCollapsed={isSidebarCollapsed} onToggleCollapse={() => setIsSidebarCollapsed(!isSidebarCollapsed)} onMobileClose={() => setIsMobileSidebarOpen(false)} data-id="element-174" />
      </div>

      {/* Header */}
      <Header isCollapsed={isSidebarCollapsed} onMobileMenuToggle={toggleMobileSidebar} data-id="element-175" />

      {/* Main content */}
      <main className={`
          pt-16 min-h-screen transition-all duration-300 ease-in-out
          ml-0 ${isSidebarCollapsed ? 'md:ml-[68px]' : 'md:ml-64'}
        `} style={{
      paddingBottom: 'calc(4.5rem + env(safe-area-inset-bottom))'
    }} data-id="element-176">
        <div className="p-3 sm:p-4 md:p-6 md:pb-6" data-id="element-177">{children}</div>
      </main>

      {/* Bottom nav (mobile) */}
      <BottomNav currentModule={currentModule} onModuleChange={onModuleChange} onOpenMenu={toggleMobileSidebar} isMenuOpen={isMobileSidebarOpen} data-id="element-178" />
    </div>;
}